import { Router } from '@lightningjs/sdk'

import Button from '../components/button/button'
import { backgroundDark, getColor, grey200, white } from '../constants/colors'
import { AppConfig } from '../services/appConfig'
import { getText } from '../utils/dictionary'
import PageHandler from './handlers/pageHandler'

export default class Error extends PageHandler {
  private _currentButton: Button

  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: getColor(backgroundDark),
      flex: {
        direction: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      },
      Title: {
        text: {
          text: '',
          textColor: getColor(white),
          fontFace: 'UniNeueBold',
          fontSize: 48,
          lineHeight: 56,
          wordWrapWidth: 720,
        },
      },
      Info: {
        flexItem: {
          marginBottom: 44,
        },
        text: {
          text: '',
          textColor: getColor(grey200),
          fontFace: 'UniNeueBold',
          fontSize: 40,
          textAlign: 'center',
          lineHeight: 48,
          wordWrapWidth: 890,
        },
      },
      Button: {
        w: 668,
        type: Button,
        label: getText('tryAgainButton'),
      },
      ExitButton: {
        flexItem: {
          marginTop: 24,
        },
        w: 668,
        type: Button,
        label: getText('exit'),
      },
      Footer: {
        flexItem: {
          marginTop: 204,
        },
        text: {
          text: '',
          textColor: getColor(grey200),
          fontFace: 'UniNeueRegular',
          fontSize: 28,
          textAlign: 'center',
          lineHeight: 36,
          wordWrapWidth: 430,
        },
      },
    }
  }

  get title() {
    return this.tag('Title')
  }

  get info() {
    return this.tag('Info')
  }

  get button() {
    return this.tag('Button') as Button
  }

  get exitButton() {
    return this.tag('ExitButton') as Button
  }

  get footer() {
    return this.tag('Footer')
  }

  get pageText(): string {
    return 'Error'
  }

  get sectionText(): string {
    return getText('genericErrorTitle')
  }

  _init() {
    this._currentButton = this.button
    this.title.text = getText('genericErrorTitle')
  }

  _getFocused() {
    return this._currentButton
  }

  _handleEnter() {
    if (this._currentButton === this.button) {
      Router.back()
    } else {
      AppConfig.shared.onShutdown()
    }
  }

  _handleBack() {
    Router.back()
  }

  _handleUp() {
    if (this._currentButton === this.exitButton) {
      this._currentButton = this.button
    }
  }

  _handleDown() {
    if (this._currentButton === this.button) {
      this._currentButton = this.exitButton
    }
  }
}
